import React,{useState,useEffect} from 'react'
import { useAuth } from '../../context/AuthContext'
import { Link, NavLink, useNavigate } from 'react-router-dom'


import moment from 'moment';
import { Home } from '@mui/icons-material';

function EssHeader() {

    const {authUser } = useAuth();

    
    return (
        <>
        <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow mb-3">
            <div className="container-fluid">
                <Link className="me-5" to="/"><img src='/globalinc.png' style={{height:40}} /><img className="ms-2" src='/images/whatsapp.png' style={{height:40}} /></Link> {/* navbar-brand  */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    { authUser.role == 4 && 
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{fontSize:"18px"}}>
                            <li className="nav-item"><NavLink className="nav-link text-center" to="/"> <Home/> Home</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link text-center" to="/attendance"> <Home/> Attendance</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link text-center" to="/work-report"> <Home/> Work Report</NavLink></li>
                            {/*
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"><Business/> SCM</NavLink>
                                <ul className="dropdown-menu">
                                    <li><NavLink className="dropdown-item" to="/product/dashboard">Manage Product</NavLink></li>        
                                </ul>
                            </li>
                            */}
                        </ul>
                    }
                    <div className=" me-auto "></div>
                    <ul className="navbar-nav">
                        <li className="nav-item dropdown">
                            <a className="btn btn-danger" style={{borderRadius:"50px"}} href="!#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> 
                                {authUser.firstName.charAt(0).toUpperCase()}
                            </a>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                                {/*<li><a className="dropdown-item" href="/auth/change-password">Change Password</a></li> */}
                                <li><hr className="dropdown-divider"/></li>
                                <li><NavLink className="dropdown-item" to="/auth/logout">Logout</NavLink></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        </>
    )
}

export default EssHeader